import { useState, useEffect } from 'react';
import type { TelegramWebApp } from '../utils/telegram';
import WebApp from '@twa-dev/sdk';
import { getCurrentEnvironment } from '../utils/environment';

export const useTelegram = () => {
  const [isReady, setIsReady] = useState(false);
  const [webApp, setWebApp] = useState<TelegramWebApp | null>(null);
  const environment = getCurrentEnvironment();

  useEffect(() => {
    // If not in Telegram environment, mark as ready but without WebApp
    if (environment !== 'telegram') {
      setIsReady(true);
      return;
    }

    // Only try to initialize WebApp in Telegram environment
    const initializeWebApp = () => {
      // console.log('Initializing WebApp...', {
      //   window: {
      //     Telegram: !!window.Telegram,
      //     WebApp: !!window.Telegram?.WebApp,
      //   },
      //   sdk: {
      //     WebApp: !!WebApp,
      //   }
      // });

      if (!window.Telegram?.WebApp) {
        // console.error('WebApp is not available in window.Telegram');
        return false;
      }

      try {
        // Initialize WebApp
        WebApp.ready();
        WebApp.expand();
        
        // Set WebApp and mark as ready
        setWebApp(window.Telegram.WebApp as TelegramWebApp);
        setIsReady(true);
        // console.log('WebApp initialized successfully');
        return true;
      } catch (error) {
        // console.error('Error initializing WebApp:', error);
        return false;
      }
    };

    // Try to initialize WebApp
    const initialized = initializeWebApp();
    if (!initialized) {
      // If initialization failed, try again in 1 second
      const timer = setTimeout(() => {
        // console.log('Retrying WebApp initialization...');
        initializeWebApp();
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, [environment]);

  return {
    webApp,
    isReady,
    isTelegram: environment === 'telegram'
  };
}; 